import styled from 'styled-components';
import {
  Select,
  DialogContent,
  TextField,
} from '@mui/material';
import colors from '../../../../../../styles/colors';

const StyledSelect = styled(Select)`
  color: ${colors.shades.gamma2};
  width: 100%;
`;

const Label = styled.div`
  font-size: 14px;
  width: 100%;
`;

const LabelTitle = styled.span`
  display: inline-block;
  color: ${colors.shades.beta1};
  width: 100px;
`;

const LabelDescription = styled.span`
  color: ${colors.shades.beta2};
`;

const StyledDialogContent = styled(DialogContent)`
  min-height: 260px;
  padding: 25px 50px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 14px;
`;

const ConfirmContent = styled(DialogContent)`
  padding: 25px 50px 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const FieldLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.shades.beta1};
`;

const AmountField = styled(TextField)`
  width: 100%;
`;

const HelperRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: ${colors.shades.gamma10};
  margin-top: -6px;
`;

const ErrorText = styled.div`
  font-size: 12px;
  color: ${colors.base.danger};
`;

const BreakdownPanel = styled.div`
  background-color: ${colors.shades.secondary5};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const BreakdownTitle = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${colors.shades.gamma10};
`;

const BreakdownRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: ${colors.shades.beta1};
  ${({ $total }) => $total
    && `
    font-weight: 700;
    color: ${colors.shades.secondary3};
    border-top: 1px solid ${colors.shades.secondary7};
    padding-top: 8px;
  `}
`;

export {
  StyledSelect,
  Label,
  LabelTitle,
  LabelDescription,
  StyledDialogContent,
  ConfirmContent,
  FieldLabel,
  AmountField,
  HelperRow,
  ErrorText,
  BreakdownPanel,
  BreakdownTitle,
  BreakdownRow,
};
